import React from 'react';
import { Button, ButtonProps } from '@mui/material';
import clsx from 'clsx';
import { useStyles } from './styles';

export const PrimaryButton: React.FC<ButtonProps> = ({ className, ...rest }) => {
  const styles = useStyles();

  return (
    <Button
      variant="contained"
      disableElevation
      fullWidth
      className={clsx(styles.button, className)}
      {...rest}
    />
  );
};
